// frontend/src/exercises/nonWordsConfig.js
const nonWordsConfig = {
    id: 'nonWords',
    titleKey: 'nonWordsTitle',
    headerColor: '#088c08',
    planetBackground: '/assets/images/general/pianeta-blu.png',
    marsImage: '/assets/images/general/back.png',
    marsSize: 200,
    character: 'Pepè',
    controlColors: {
        repeat: 'yellow',
        record: 'lightgray',
        check: 'lightgreen'
    },
    instructionsKey: 'nonWordsInstructions',
    showNotes: true,
    // words array will be dynamically loaded from headerText.js
    totalLevels: 15, // Ensure this matches the number of word arrays in headerText.js for nonWords
};

export default nonWordsConfig;
